import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

import {
	IGetPromptuaryExportInfo,
	IPromptuaryExportData,
} from '../interfaces/export.interface';

@Injectable({
	providedIn: 'root',
})
export class ExportService {
	servicesUrl = environment.servicesUrl;

	constructor(private httpClient: HttpClient) {}

	exportPromptuary(exportData: IPromptuaryExportData) {
		return this.httpClient.post<any>(
			`${this.servicesUrl}/promptuary/v1/promptuary/export`,
			{
				reason: exportData.reason,
				reasonDetails: exportData.reasonDetails,
				startDate: exportData.startDate,
				endDate: exportData.endDate,
				customerId: exportData.customerId,
			}
		);
	}

	getExportData(id: string) {
		return this.httpClient.get<IGetPromptuaryExportInfo>(
			`${this.servicesUrl}/promptuary/v1/promptuary/export/${id}`
		);
	}

	downloadPromptuary(id: string, token: string) {
		return this.httpClient.get<Blob>(
			`${this.servicesUrl}/promptuary/v1/promptuary/export/${id}/download`,
			{
				responseType: 'blob' as 'json',
				observe: 'response',
				params: { 'grecaptcha-key': token },
			}
		);
	}
}
